/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter your last name" |
*
* @param {Last_Name_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const last_name_placeholder = /** @type {((inputs?: Last_Name_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Name_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enter your last name")
	return /** @type {LocalizedString} */ ("Saisissez votre nom")
});